export default {
  trainings: state => state.trainings,
  maxTrainings: state => state.maxTrainings,
  sessions: state => state.sessions,
  maxSessions: state => state.maxSessions,
  trainees: state => state.trainees,
  maxTrainees: state => state.maxTrainee
}
